{
  "profile": "Ver Perfil",
  "selected": "Seleccionado",
  "log_out": "Salir",
  "terms_services": "Términos de servicio ",
  "agencies": "Agencias",
  "all-agencies": "Todas las agencias",
  "chargeSettings": "Configuración de Cargos",
  "aiUsage": "Uso de IA",
  "aiConfig": {
    "title": "Opciones de IA"
  }
}
